/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { TemplateCellModel } from "./TemplateCellModel";
import { CellModel } from "./CellModel";
import { markType } from "igniteui-react-core";
import { TemplateHeaderCellModelExport } from "./TemplateHeaderCellModelExport";
/**
 * @hidden
 */
var TemplateHeaderCellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TemplateHeaderCellModel, _super);
    function TemplateHeaderCellModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.k0 = false;
        return _this;
    }
    Object.defineProperty(TemplateHeaderCellModel.prototype, "k1", {
        get: function () {
            return this.k0;
        },
        set: function (a) {
            var b = this.k0;
            this.k0 = a;
            if (this.k0 != b) {
                this.jo("IsFilterUIVisible", TemplateHeaderCellModel.k2, b, this.k0);
            }
        },
        enumerable: true,
        configurable: true
    });
    TemplateHeaderCellModel.prototype.jw = function (a, b) {
        _super.prototype.jw.call(this, a, b);
        if (a == "IsFilterUIVisible") {
            this.k1 = b;
        }
    };
    TemplateHeaderCellModel.prototype.go = function (a) {
        if (a == "IsFilterUIVisible") {
            return this.k1;
        }
        return _super.prototype.go.call(this, a);
    };
    TemplateHeaderCellModel.prototype.b = function (a) {
        if (a == null) {
            a = new TemplateHeaderCellModelExport();
        }
        a = _super.prototype.b.call(this, a);
        var b = a;
        b.ae = this.ky;
        return b;
    };
    TemplateHeaderCellModel.$t = markType(TemplateHeaderCellModel, 'TemplateHeaderCellModel', TemplateCellModel.$);
    TemplateHeaderCellModel.k2 = CellModel.ez("IsFilterUIVisible");
    return TemplateHeaderCellModel;
}(TemplateCellModel));
export { TemplateHeaderCellModel };
//# sourceMappingURL=TemplateHeaderCellModel.js.map
